import styled from 'styled-components';

import TabsCard from 'styled/components/TabsCard';

export default styled(TabsCard)`
  .content {
    min-height: 450px;
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: 25px auto auto;
  }

  .ball-possession {
    display: flex;
    justify-content: space-between;
    padding: 0 40px;

    .team-name {
      font-size: 14px;
      text-transform: uppercase;
      font-weight: 700;
    }
  }

  .automatic {
    display: grid;
    grid-template-columns: 1fr;
    justify-content: space-between;
    width: 100%;
    grid-gap: 10px;
    padding: 0 45px;
    box-sizing: border-box;
  }

  .dynamic {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 20px;
    margin-bottom: 20px;
    padding: 0 26px;
  }
`;

const styledField = styled.div`
  .statsCircle {
    width: 20px;
    height: 20px;
    background-color: #83bbaf;
    text-align: center;
    line-height: 20px;
    border-radius: 50%;
    font-size: 14px;
  }
`;

export const StyledAutomaticField = styled(styledField)`
  display: flex;
  justify-content: space-between;
  align-items: center;

  div.label {
    opacity: 0.5;
  }
`;

export const StyledDynamicField = styled(styledField)`
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  justify-content: space-between;
  grid-gap: 6px;
  align-items: center;

  .middle {
    display: flex;
    flex-direction: column;
    align-items: center;

    .toggle-container {
      display: flex;

      label {
        margin-right: 4px;
      }
    }
  }

  .manual {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .add,
    .subtract {
      cursor: pointer;
    }

    .disabled.add,
    .disabled.subtract {
      cursor: not-allowed !important;
    }

    .subtract {
      width: 14px;
      height: 14px;
    }

    .add {
      width: 30px;
      height: 30px;
    }
  }

  .auto,
  .value {
    font-size: 14px;
  }

  .auto {
    text-align: center;
  }

  .home {
    margin: 0 auto;
    .auto {
      padding-right: 7px;
    }
  }

  .away {
    margin: 0 auto;
    .auto {
      padding-left: 7px;
    }
  }

  .value {
    border-radius: 4px;
    margin-left: 4px;
    margin-right: 4px;
  }

  .alert-choose {
    background-color: #eff1f4;
    padding: 4px;

    animation: yellow-blink 1s;
    animation-iteration-count: 4;
  }

  @keyframes yellow-blink {
    50% {
      background-color: #ffff00;
      padding: 0;
    }
  }
`;
